import { gql } from '../types/generated';

export const GET_PIPELINE_INPUT_CONFIGS = gql(`
  query pipelineInputConfigs($venueId: Int!, $region: Region) {
    pipelineInputConfigs(venueId: $venueId, region: $region) {
      id
      venueId
      feedTypeCode
      inputLabel
      category
      region
    }
  }
`);
